import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import _uniqWith from 'lodash/uniqWith';
import { DashboardTicket, DashboardTicketsMetaData } from 'Interfaces/Ticket/Ticket';
import { TicketScore } from 'generated/graphql';
import { TicketLocation, ticketInitialState } from './state';

const removeTicket = (tickets: DashboardTicket[], ticketIndex: TicketLocation): DashboardTicket[] => {
    return tickets.filter((ticket) => {
        if (ticket.ticketId === ticketIndex.ticketId && ticket.uid === ticketIndex.reviewerId) {
            return false;
        }
        return true;
    });
};

const addNewTicket = (ticketToBeAdded: DashboardTicket[], currentTickets: DashboardTicket[]): DashboardTicket[] => {
    return _uniqWith(
        [...ticketToBeAdded, ...currentTickets],
        (prevValue, nextValue) => prevValue.uid === nextValue.uid && prevValue.ticketId === nextValue.ticketId,
    );
};

const ticketSlice = createSlice({
    name: 'ticket',
    initialState: ticketInitialState,
    reducers: {
        SAVE_UPDATED_TICKETS_BACKUP: (state, action: PayloadAction<DashboardTicket[]>) => {
            const tickets = action.payload;
            return {
                ...state,
                updatedTicketsBackup: tickets,
            };
        },

        CLEAN_TICKET_DATA: (state) => {
            return {
                ...state,
                tickets: [],
            };
        },
        SAVE_UPDATED_TICKET_DATA: (state, action: PayloadAction<DashboardTicket[]>) => {
            const updatedTickets = action.payload;
            return {
                ...state,
                updatedTickets,
            };
        },

        SAVE_DASHBOARD_TICKETS_METADATA: (state, action: PayloadAction<DashboardTicketsMetaData>) => {
            const metadata = action.payload;
            return {
                ...state,
                dashboardTicketsMetada: metadata,
            };
        },

        CLEAN_UPDATED_TICKET_DATA: (state) => {
            return {
                ...state,
                updatedTickets: [],
            };
        },
        REMOVE_SINGLE_TICKET_DATA: (state, action: PayloadAction<TicketLocation>) => {
            const ticketIndex = action.payload;

            return {
                ...state,
                updatedTickets: removeTicket(state.updatedTickets, ticketIndex),
                updatedTicketsBackup: removeTicket(state.updatedTicketsBackup, ticketIndex),
            };
        },
        ADD_NEW_TICKET_TO_TICKET_LIST: (state, action: PayloadAction<TicketScore[]>) => {
            const newTicket = action.payload;
            return {
                ...state,
                updatedTickets: addNewTicket(newTicket, state.updatedTickets),
                updatedTicketsBackup: addNewTicket(newTicket, state.updatedTicketsBackup),
            };
        },
        APPLY_UPDATED_TICKETS_BACKUP: (state) => {
            return {
                ...state,
                updatedTickets: state.updatedTicketsBackup,
            };
        },
    },
});

export const { reducer: ticketReducer, actions: ticketActions } = ticketSlice;
